module.exports = __webpack_public_path__ + "static/media/icon_billing_orange.e068002c.svg";